import ProgressRing from "../components/ProgressRing";

const CancelRegistrationState = {
    INITIAL_STATE: "Uitschrijven",
    LOADING: <ProgressRing/>,
}

export default CancelRegistrationState;